import React from 'react';
import './Recommendations.css';
import guitar from '../assets/guitar.png';
import printer from '../assets/printer.png';
import tablet from '../assets/tablet.png';
import watch from '../assets/watch.png';
import kettle from '../assets/kettle.png';
import heater from '../assets/heater.png';


const Recommendations = () => {
  return (
    <section className="recommendations">
      <h2 className="recommendations-title">Recommendation</h2>
      <div className="recommendation-list">
        {/* Guitar */}
        <div className="recommendation-card" style={{ backgroundColor: '#DFFFD6' }}>
          <img src={guitar} alt="Guitar" className="recommendation-image" />
        </div>


        {/* Printer */}
        <div className="recommendation-card" style={{ backgroundColor: '#F0F0F0' }}>
          <img src={printer} alt="Printer" className="recommendation-image" />
        </div>


        {/* Tablet */}
        <div className="recommendation-card" style={{ backgroundColor: '#FFE4E1' }}>
          <img src={tablet} alt="Tablet" className="recommendation-image" />
        </div>


        {/* Watch */}
        <div className="recommendation-card" style={{ backgroundColor: '#FFE4C4' }}>
          <img src={watch} alt="Watch" className="recommendation-image" />
        </div>


        {/* Kettle */}
        <div className="recommendation-card" style={{ backgroundColor: '#FFF9C4' }}>
          <img src={kettle} alt="Kettle" className="recommendation-image" />
        </div>


        {/* Heater */}
        <div className="recommendation-card" style={{ backgroundColor: '#D9F0FF' }}>
          <img src={heater} alt="Heater" className="recommendation-image" />
        </div>
      </div>
    </section>
  );
};


export default Recommendations;
